export default "__VITE_ASSET__f39c51e8__"